import React from 'react';
import { cn } from '../../lib/utils';

/**
 * StampBadge — cachet/tampon style « carnet de bord ».
 *
 * Usage : afficher un état (Terminé, Examiné, Validate, etc.) avec
 * la sensation d'un cachet humide encré sur le papier.
 */
export const StampBadge = ({
  label = 'VALIDÉ',
  date,
  rotated = true,
  color,
  className,
  ...props
}) => {
  const stampColor = color || 'hsl(var(--primary))';
  return (
    <div
      className={cn(
        'inline-flex flex-col items-center gap-0.5 px-3 py-1.5 border-2 select-none',
        rotated && '-rotate-3',
        className,
      )}
      style={{
        color: stampColor,
        borderColor: stampColor,
        borderRadius: 4,
        fontFamily: "'Source Code Pro', monospace",
        textTransform: 'uppercase',
        letterSpacing: '0.18em',
        opacity: 0.88,
      }}
      data-testid="stamp-badge"
      {...props}
    >
      <span className="text-[11px] sm:text-xs font-black">{label}</span>
      {date && <span className="text-[8px] sm:text-[9px] font-bold opacity-80">{date}</span>}
    </div>
  );
};

export default StampBadge;
